import { flattenErrors } from "./flattenErrors.ts";
import { ValidationResult } from "./validation.types.ts";

export const isValid = (result: ValidationResult): boolean =>
  flattenErrors(result).every(x => !x);
